"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_21bifp0zte = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organization/Organization.js";
  var hash = "3274173a32c7f12c8e7caf3c991f725b6c9e86d3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organization/Organization.js",
    statementMap: {
      "0": {
        start: {
          line: 20,
          column: 18
        },
        end: {
          line: 23,
          column: 3
        }
      },
      "1": {
        start: {
          line: 20,
          column: 41
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "2": {
        start: {
          line: 39,
          column: 18
        },
        end: {
          line: 39,
          column: 29
        }
      },
      "3": {
        start: {
          line: 40,
          column: 24
        },
        end: {
          line: 40,
          column: 46
        }
      },
      "4": {
        start: {
          line: 41,
          column: 32
        },
        end: {
          line: 41,
          column: 46
        }
      },
      "5": {
        start: {
          line: 42,
          column: 43
        },
        end: {
          line: 42,
          column: 82
        }
      },
      "6": {
        start: {
          line: 44,
          column: 18
        },
        end: {
          line: 47,
          column: 8
        }
      },
      "7": {
        start: {
          line: 45,
          column: 17
        },
        end: {
          line: 45,
          column: 58
        }
      },
      "8": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 17
        }
      },
      "9": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 57,
          column: 43
        }
      },
      "10": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      "11": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 23
        }
      },
      "12": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 31
        }
      },
      "13": {
        start: {
          line: 53,
          column: 11
        },
        end: {
          line: 55,
          column: 5
        }
      },
      "14": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 27
        }
      },
      "15": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 22
        }
      },
      "16": {
        start: {
          line: 59,
          column: 26
        },
        end: {
          line: 87,
          column: 27
        }
      },
      "17": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 63,
          column: 5
        }
      },
      "18": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 26
        }
      },
      "19": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 13
        }
      },
      "20": {
        start: {
          line: 67,
          column: 15
        },
        end: {
          line: 67,
          column: 47
        }
      },
      "21": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 71,
          column: 5
        }
      },
      "22": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 26
        }
      },
      "23": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 70,
          column: 13
        }
      },
      "24": {
        start: {
          line: 77,
          column: 32
        },
        end: {
          line: 77,
          column: 78
        }
      },
      "25": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "26": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 83,
          column: 8
        }
      },
      "27": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 26
        }
      },
      "28": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 15
        }
      },
      "29": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 97,
          column: 26
        }
      },
      "30": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 76
        }
      },
      "31": {
        start: {
          line: 100,
          column: 2
        },
        end: {
          line: 139,
          column: 4
        }
      },
      "32": {
        start: {
          line: 131,
          column: 14
        },
        end: {
          line: 131,
          column: 45
        }
      },
      "33": {
        start: {
          line: 142,
          column: 0
        },
        end: {
          line: 168,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 29
          },
          end: {
            line: 20,
            column: 30
          }
        },
        loc: {
          start: {
            line: 20,
            column: 41
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "Organization",
        decl: {
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 25,
            column: 21
          }
        },
        loc: {
          start: {
            line: 38,
            column: 3
          },
          end: {
            line: 140,
            column: 1
          }
        },
        line: 38
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 29,
            column: 19
          },
          end: {
            line: 29,
            column: 20
          }
        },
        loc: {
          start: {
            line: 29,
            column: 25
          },
          end: {
            line: 29,
            column: 27
          }
        },
        line: 29
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 44,
            column: 30
          },
          end: {
            line: 44,
            column: 31
          }
        },
        loc: {
          start: {
            line: 44,
            column: 72
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 44
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 49,
            column: 12
          },
          end: {
            line: 49,
            column: 13
          }
        },
        loc: {
          start: {
            line: 49,
            column: 18
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 49
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 59,
            column: 38
          },
          end: {
            line: 59,
            column: 39
          }
        },
        loc: {
          start: {
            line: 59,
            column: 50
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 59
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 130,
            column: 21
          },
          end: {
            line: 130,
            column: 22
          }
        },
        loc: {
          start: {
            line: 130,
            column: 27
          },
          end: {
            line: 132,
            column: 13
          }
        },
        line: 130
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 10
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 26,
            column: 10
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 13
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 27,
            column: 11
          },
          end: {
            line: 27,
            column: 13
          }
        }],
        line: 27
      },
      "2": {
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 29,
            column: 19
          },
          end: {
            line: 29,
            column: 27
          }
        }],
        line: 29
      },
      "3": {
        loc: {
          start: {
            line: 31,
            column: 12
          },
          end: {
            line: 37,
            column: 8
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 37,
            column: 8
          }
        }],
        line: 31
      },
      "4": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 32,
            column: 21
          },
          end: {
            line: 32,
            column: 31
          }
        }],
        line: 32
      },
      "5": {
        loc: {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 33,
            column: 65
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 33,
            column: 23
          },
          end: {
            line: 33,
            column: 65
          }
        }],
        line: 33
      },
      "6": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 35,
            column: 19
          },
          end: {
            line: 35,
            column: 36
          }
        }],
        line: 35
      },
      "7": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 73
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 36,
            column: 21
          },
          end: {
            line: 36,
            column: 73
          }
        }],
        line: 36
      },
      "8": {
        loc: {
          start: {
            line: 42,
            column: 43
          },
          end: {
            line: 42,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 43
          },
          end: {
            line: 42,
            column: 76
          }
        }, {
          start: {
            line: 42,
            column: 80
          },
          end: {
            line: 42,
            column: 82
          }
        }],
        line: 42
      },
      "9": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }],
        line: 50
      },
      "10": {
        loc: {
          start: {
            line: 53,
            column: 11
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 11
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 11
          },
          end: {
            line: 55,
            column: 5
          }
        }],
        line: 53
      },
      "11": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }, {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }],
        line: 60
      },
      "12": {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }, {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }],
        line: 68
      },
      "13": {
        loc: {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }],
        line: 78
      },
      "14": {
        loc: {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 91,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 91,
            column: 9
          }
        }, {
          start: {
            line: 91,
            column: 13
          },
          end: {
            line: 91,
            column: 15
          }
        }],
        line: 91
      },
      "15": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 97,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 13
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 12
          }
        }, {
          start: {
            line: 96,
            column: 5
          },
          end: {
            line: 96,
            column: 12
          }
        }, {
          start: {
            line: 96,
            column: 16
          },
          end: {
            line: 96,
            column: 30
          }
        }, {
          start: {
            line: 97,
            column: 5
          },
          end: {
            line: 97,
            column: 9
          }
        }, {
          start: {
            line: 97,
            column: 13
          },
          end: {
            line: 97,
            column: 25
          }
        }],
        line: 94
      },
      "16": {
        loc: {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 99,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 99,
            column: 15
          }
        }, {
          start: {
            line: 99,
            column: 20
          },
          end: {
            line: 99,
            column: 27
          }
        }, {
          start: {
            line: 99,
            column: 31
          },
          end: {
            line: 99,
            column: 47
          }
        }, {
          start: {
            line: 99,
            column: 53
          },
          end: {
            line: 99,
            column: 57
          }
        }, {
          start: {
            line: 99,
            column: 61
          },
          end: {
            line: 99,
            column: 75
          }
        }],
        line: 99
      },
      "17": {
        loc: {
          start: {
            line: 111,
            column: 15
          },
          end: {
            line: 111,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 111,
            column: 15
          },
          end: {
            line: 111,
            column: 24
          }
        }, {
          start: {
            line: 111,
            column: 28
          },
          end: {
            line: 111,
            column: 36
          }
        }],
        line: 111
      },
      "18": {
        loc: {
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 123,
            column: 20
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 122,
            column: 16
          },
          end: {
            line: 122,
            column: 36
          }
        }, {
          start: {
            line: 123,
            column: 16
          },
          end: {
            line: 123,
            column: 20
          }
        }],
        line: 121
      },
      "19": {
        loc: {
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 121,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 121,
            column: 29
          }
        }, {
          start: {
            line: 121,
            column: 33
          },
          end: {
            line: 121,
            column: 49
          }
        }, {
          start: {
            line: 121,
            column: 53
          },
          end: {
            line: 121,
            column: 69
          }
        }],
        line: 121
      },
      "20": {
        loc: {
          start: {
            line: 126,
            column: 7
          },
          end: {
            line: 137,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 7
          },
          end: {
            line: 126,
            column: 10
          }
        }, {
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 136,
            column: 34
          }
        }],
        line: 126
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0],
      "6": [0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0, 0, 0, 0],
      "16": [0, 0, 0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0],
      "20": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "3274173a32c7f12c8e7caf3c991f725b6c9e86d3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useDeepCompareEffect = _interopRequireDefault(require("use-deep-compare-effect"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _path = _interopRequireDefault(require("path"));

var _ = require("..");

var _icons = require("@material-ui/icons");

var _core2 = require("../../core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var useStyles = (cov_21bifp0zte.s[0]++, (0, _styles.makeStyles)(function (theme) {
  cov_21bifp0zte.f[0]++;
  cov_21bifp0zte.s[1]++;
  return {
    avatar: {
      borderRadius: '20%'
    },
    errorMessage: {
      color: _core.colors.red[500]
    }
  };
}));

function Organization(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? (cov_21bifp0zte.b[0][0]++, '') : _ref$url,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? (cov_21bifp0zte.b[1][0]++, {}) : _ref$config,
      organization = _ref.organization,
      _ref$onOrganization = _ref.onOrganization,
      onOrganization = _ref$onOrganization === void 0 ? (cov_21bifp0zte.b[2][0]++, function () {
    cov_21bifp0zte.f[2]++;
  }) : _ref$onOrganization,
      selected = _ref.selected,
      _ref$messages = _ref.messages;
  _ref$messages = _ref$messages === void 0 ? (cov_21bifp0zte.b[3][0]++, {}) : _ref$messages;
  var _ref$messages$primary = _ref$messages.primaryLoading,
      primaryLoading = _ref$messages$primary === void 0 ? (cov_21bifp0zte.b[4][0]++, 'Loading…') : _ref$messages$primary,
      _ref$messages$seconda = _ref$messages.secondaryLoading,
      secondaryLoading = _ref$messages$seconda === void 0 ? (cov_21bifp0zte.b[5][0]++, 'Attempting to load organization details…') : _ref$messages$seconda,
      _ref$messages$primary2 = _ref$messages.primaryError,
      primaryError = _ref$messages$primary2 === void 0 ? (cov_21bifp0zte.b[6][0]++, 'No organization') : _ref$messages$primary2,
      _ref$messages$seconda2 = _ref$messages.secondaryError,
      secondaryError = _ref$messages$seconda2 === void 0 ? (cov_21bifp0zte.b[7][0]++, 'Please provide a valid organization object or url.') : _ref$messages$seconda2;
  cov_21bifp0zte.f[1]++;
  var classes = (cov_21bifp0zte.s[2]++, useStyles());

  var _ref2 = (cov_21bifp0zte.s[3]++, (0, _react.useState)(organization)),
      _ref3 = _slicedToArray(_ref2, 2),
      org = _ref3[0],
      setOrg = _ref3[1];

  var _ref4 = (cov_21bifp0zte.s[4]++, (0, _react.useState)(true)),
      _ref5 = _slicedToArray(_ref4, 2),
      loading = _ref5[0],
      setLoading = _ref5[1];

  var _ref6 = (cov_21bifp0zte.s[5]++, (cov_21bifp0zte.b[8][0]++, (0, _react.useContext)(_.AuthenticationContext)) || (cov_21bifp0zte.b[8][1]++, {})),
      contextAuthentication = _ref6.state;

  var getData = (cov_21bifp0zte.s[6]++, (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref7) {
      var _config, _url, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _config = _ref7.config, _url = _ref7.url;
              cov_21bifp0zte.f[3]++;
              cov_21bifp0zte.s[7]++;
              _context.next = 5;
              return (0, _core2.get)({
                config: _config,
                url: _url
              });

            case 5:
              data = _context.sent;
              cov_21bifp0zte.s[8]++;
              setOrg(data);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref8.apply(this, arguments);
    };
  }(), []));
  cov_21bifp0zte.s[9]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_21bifp0zte.f[4]++;
    cov_21bifp0zte.s[10]++;

    if (url) {
      cov_21bifp0zte.b[9][0]++;
      cov_21bifp0zte.s[11]++;
      setLoading(true);
      cov_21bifp0zte.s[12]++;
      getData({
        config: config,
        url: url
      });
    } else {
      cov_21bifp0zte.b[9][1]++;
      cov_21bifp0zte.s[13]++;

      if (organization) {
        cov_21bifp0zte.b[10][0]++;
        cov_21bifp0zte.s[14]++;
        setOrg(organization);
      } else {
        cov_21bifp0zte.b[10][1]++;
      }
    }

    cov_21bifp0zte.s[15]++;
    setLoading(false);
  }, [url, organization, config, getData]);

  var _onOrganization = (cov_21bifp0zte.s[16]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var user, hasWritePermissions;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cov_21bifp0zte.f[5]++;
            cov_21bifp0zte.s[17]++;

            if (!(org === undefined)) {
              _context2.next = 10;
              break;
            }

            cov_21bifp0zte.b[11][0]++;
            cov_21bifp0zte.s[18]++;
            onOrganization(org);
            cov_21bifp0zte.s[19]++;
            return _context2.abrupt("return");

          case 10:
            cov_21bifp0zte.b[11][1]++;

          case 11:
            // first get the user (if logged in)
            // if not logged in, go ahead and set the org
            user = (cov_21bifp0zte.s[20]++, contextAuthentication.user.login);
            cov_21bifp0zte.s[21]++;

            if (user) {
              _context2.next = 21;
              break;
            }

            cov_21bifp0zte.b[12][0]++;
            cov_21bifp0zte.s[22]++;
            onOrganization(org);
            cov_21bifp0zte.s[23]++;
            return _context2.abrupt("return");

          case 21:
            cov_21bifp0zte.b[12][1]++;

          case 22:
            cov_21bifp0zte.s[24]++;
            _context2.next = 25;
            return (0, _core2.isSelectedOrgWritable)({
              org: org,
              user: user,
              config: config
            });

          case 25:
            hasWritePermissions = _context2.sent;
            cov_21bifp0zte.s[25]++;

            if (!hasWritePermissions) {
              cov_21bifp0zte.b[13][0]++;
              cov_21bifp0zte.s[26]++;
              alert("Your door43 user account doesn't have permission to edit the " + "files in the organization you have chosen.\n" + "Please contact your organization administrator and request write permissions.");
            } else {
              cov_21bifp0zte.b[13][1]++;
              cov_21bifp0zte.s[27]++;
              onOrganization(org);
            }

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [org, onOrganization]));

  var _ref10 = (cov_21bifp0zte.s[28]++, (cov_21bifp0zte.b[14][0]++, org) || (cov_21bifp0zte.b[14][1]++, {})),
      avatar_url = _ref10.avatar_url,
      description = _ref10.description,
      full_name = _ref10.full_name,
      username = _ref10.username,
      website = _ref10.website;

  var primary = (cov_21bifp0zte.s[29]++, (cov_21bifp0zte.b[15][0]++, full_name) || (cov_21bifp0zte.b[15][1]++, username) || (cov_21bifp0zte.b[15][2]++, loading) && (cov_21bifp0zte.b[15][3]++, primaryLoading) || (cov_21bifp0zte.b[15][4]++, !org) && (cov_21bifp0zte.b[15][5]++, primaryError));
  var secondary = (cov_21bifp0zte.s[30]++, (cov_21bifp0zte.b[16][0]++, description) || (cov_21bifp0zte.b[16][1]++, loading) && (cov_21bifp0zte.b[16][2]++, secondaryLoading) || (cov_21bifp0zte.b[16][3]++, !org) && (cov_21bifp0zte.b[16][4]++, secondaryError));
  cov_21bifp0zte.s[31]++;
  return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    selected: selected,
    "data-test": "organization-item",
    alignItems: "flex-start",
    button: true,
    ContainerComponent: "div",
    onClick: _onOrganization
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, null, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    alt: (cov_21bifp0zte.b[17][0]++, full_name) || (cov_21bifp0zte.b[17][1]++, username),
    src: avatar_url,
    className: classes.avatar
  })), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: primary,
    secondary: secondary,
    classes: {
      secondary: (cov_21bifp0zte.b[19][0]++, full_name == null) && (cov_21bifp0zte.b[19][1]++, username == null) && (cov_21bifp0zte.b[19][2]++, loading !== true) ? (cov_21bifp0zte.b[18][0]++, classes.errorMessage) : (cov_21bifp0zte.b[18][1]++, null)
    }
  }), (cov_21bifp0zte.b[20][0]++, org) && (cov_21bifp0zte.b[20][1]++, /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "Open Link",
    onClick: function onClick() {
      cov_21bifp0zte.f[6]++;
      cov_21bifp0zte.s[32]++;
      window.open(website, '_blank');
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Code, null)))));
}

cov_21bifp0zte.s[33]++;
Organization.propTypes = {
  /** Organization data to render, if url not provided. */
  organization: _propTypes.default.shape({
    avatar_url: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired,
    full_name: _propTypes.default.string.isRequired,
    id: _propTypes.default.number.isRequired,
    location: _propTypes.default.string.isRequired,
    username: _propTypes.default.string.isRequired,
    visibility: _propTypes.default.string.isRequired,
    website: _propTypes.default.string.isRequired
  }),

  /** Function to call when organization is selected. */
  onOrganization: _propTypes.default.func.isRequired,

  /** Url to get organization data, if organization data is not provided. */
  url: _propTypes.default.string,

  /** Configuration required if paths are provided as URL. */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired
  }),

  /** The selected organization */
  selected: _propTypes.default.bool,
  messages: _propTypes.default.shape({
    primaryError: _propTypes.default.string,
    secondaryError: _propTypes.default.string,
    primaryLoading: _propTypes.default.string,
    secondaryLoading: _propTypes.default.string
  })
};
var _default = Organization;
exports.default = _default;